<template>
  <Select
    :class="floatingLabel ? 'select-v2' : 'dropdown-steady'"
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    autocomplete="new-password"
    filterable
    :filter-method="filterMethod"
    :popper-append-to-body="false"
  >
    <Option
      v-for="option in options"
      :key="option.key"
      :label="option.value"
      :value="option.key"
      :data-test="`${prefix}_option_${option.kind}_${option.key}`"
    />
  </Select>
</template>

<script>
import { COUNTRY_SUBDIVISIONS_QUERY } from '~/queries';
import filterMethod from '~/filters/filterOptions';

export default {
  name: 'CountrySubdivisionSelect',
  props: {
    floatingLabel: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
    country: {
      type: String,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      options: [],
    };
  },
  apollo: {
    countrySubdivisions: {
      query: COUNTRY_SUBDIVISIONS_QUERY,
      variables() {
        return {
          country: this.country,
        };
      },
      result({ data }) {
        this.countrySubdivisions = data.countrySubdivisions;
        this.options = data.countrySubdivisions;
      },
    },
  },
  methods: {
    filterMethod(filterValue) {
      this.options = filterMethod(this.countrySubdivisions, filterValue);
    },
  },
};
</script>
